// import { useAuth0 } from '@auth0/auth0-react';
// import { NavbarHead, Navigation, Links } from './NavBarStyles';
// import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';

// export const Navbar = () => {
//   const { isAuthenticated } = useAuth0();
//   const { t } = useTranslation();
//   return (
//     <>
//       {isAuthenticated ? (
//         <NavbarHead>
//           <Navigation>
//             <Links as={Link} to="/" passHref>
//               {t('start')}
//             </Links>
//             <Links as={Link} to="/insulinFactor" passHref>
//               {t('insulin')} <br />
//               {t('factor')}
//             </Links>
//             <Links as={Link} to="/correctionFactor" passHref>
//               {t('correction')} <br />
//               {t('factor')}
//             </Links>
//             <Links as={Link} to="/savedInsulinData" passHref>
//               {t('data')}
//             </Links>
//           </Navigation>
//         </NavbarHead>
//       ) : null}
//     </>
//   );
// };


import { useAuth0 } from '@auth0/auth0-react';
import {
  NavbarHead,
  Navigation,
  Links,
  Burger,
  MobileMenu,
  Overlay,
  UserData,
} from './NavBarStyles';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import DeleteUserDataButton from '../DeleteUserData/DeleteUserData';
import LogoutButton from '../Login/Loggout';

export const Navbar = () => {
  const { isAuthenticated } = useAuth0();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const toggleMenu = () => setOpen(!open);
  const closeMenu = () => setOpen(false);

  return (
    <>
      {isAuthenticated && (
        <>
          <NavbarHead>
            <Burger open={open} onClick={toggleMenu}>
              <div />
              <div />
              <div />
            </Burger>
            <Navigation>
              <Links as={Link} to="/" passHref>{t('start')}</Links>
              <Links as={Link} to="/insulinFactor" passHref>
                {t('insulin')} <br /> {t('factor')}
              </Links>
              <Links as={Link} to="/correctionFactor" passHref>
                {t('correction')} <br /> {t('factor')}
              </Links>
              <Links as={Link} to="/savedInsulinData" passHref>{t('data')}</Links>
             <DeleteUserDataButton />
              <LogoutButton />
            </Navigation>
          </NavbarHead>

          <Overlay open={open} onClick={closeMenu} />
          <MobileMenu open={open}>
            <Links as={Link} to="/" onClick={closeMenu}>{t('start')}</Links>
            <Links as={Link} to="/insulinFactor" onClick={closeMenu}>
              {t('insulin')} <br /> {t('factor')}
            </Links>
            <Links as={Link} to="/correctionFactor" onClick={closeMenu}>
              {t('correction')} <br /> {t('factor')}
            </Links>
            <Links as={Link} to="/savedInsulinData" onClick={closeMenu}>{t('data')}</Links>
            <UserData>
             <LogoutButton />
            <DeleteUserDataButton />
             </UserData>
          </MobileMenu>
        </>
      )}
    </>
  );
};
